import { useState, useEffect } from "react";
import "./layoutselection.css";
import layout1 from "./assets/layout1.png";
import layout2 from "./assets/layout2.png";
import { Button } from "reactstrap";
import httpService from "./services/http.service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import SuccessMessage from "./components/common/successMsg";
import WarningMessage from "./components/common/warnMsg";
import { useHistory } from "react-router-dom";
import ErrorMessage from "./components/common/errorMsg";

let LayoutSelection = (props) => {
  const [layoutType, setlayoutType] = useState("1");
  const [layoutName, setlayoutName] = useState("");
  const [array2, setArray2] = useState([]);
  const [propertyData, setpropertyData] = useState([]);
  const [PropertyId] = useState("");
  const history = useHistory();

  // useEffect(() => { }, [layoutType, layoutName]);
  useEffect(() => {
    loadProperty();
  }, []);

  useEffect(() => {
    // check token is verify or not for the cloud user and the property user
    if (!props.verifyTokenUser && history.location.pathname != '/cloudlogin') history.push('/cloudlogin')
    // if (!props.verifyTokenUser && history.location.pathname != '/login') history.push('/login')
    
  }, [props.verifyTokenUser])


  const setLayoutTypeDB = (type) => {
    setlayoutType(type);
  };

  const handlePropertyForLayout = (selectedValue) => {
    setpropertyData(selectedValue);
  };
  const ProceedToThisLayout = async () => {
    if (layoutName === "") {
      WarningMessage("Please enter the layout name")
      return;
    }
    if (propertyData.length === 0) {
      WarningMessage("Please select the property")
      return;
    }
    let data = {
      selectedLayout: layoutType,
      name: layoutName.trim(),
      propertyData: propertyData,
      // PropertyName: PropertyName,
      // PropertyId: PropertyId,
      userID: localStorage.getItem("UserId"),
    };
    const Layout = await httpService
      .CreateUpdate("saveSelectedLayout", data)
      .catch((err) => {
        return;
      });
    props.setlayoutCheck(true);
    SuccessMessage("Layout added successfully")
  };
  const loadProperty = async () => {
    const UserId = localStorage.getItem("UserId");
    let req = {
      UserId: JSON.stringify(UserId),
    };
    let allPropertydata = await httpService
      .CreateUpdate("getallProperty", req)
      .catch((err) => {
        if (err && err.response && err.response.status == 401 && localStorage.getItem("UserId")) {
          ErrorMessage("Session expired, please login again")
        }
        history.push("/")
        localStorage.clear()
        return;
      });

    const arr2 = [];
    for (let i = 0; i < allPropertydata.data.length; i++) {
      let obj = {
        value: `${allPropertydata.data[i]._id}`,
        label: `${allPropertydata.data[i].Name}`,
        PropertyId: `${allPropertydata.data[i]._id}`,
      };
      if (allPropertydata.data[i]) {
        {
          arr2.push(obj);
        }
      }
    }
    setArray2(arr2);
  };


  return (
    <div>
      <b style={{ fontSize: "14px" }}>Property</b>
      <b style={{ color: "red" }}>*</b>
      {/* <Select
        options={array2}
        placeholder="Choose Property"
        defaultInputValue={PropertyId}
        style={{ marginBottom: "15px" }}
        onChange={(event) => {
          setPropertyName(event.label);
          setPropertyId(event.PropertyId);
        }}
      /> */}

      <Select
        isMulti
        name="Rule Type"
        options={array2}
        defaultInputValue={PropertyId}
        style={{ marginBottom: "15px" }}
        onChange={handlePropertyForLayout}
        className="basic-multi-select"
        classNamePrefix="select"
      />


      <label style={{ marginTop: "15px" }}>
        <b>Enter the Layout Name </b>
        <b style={{ color: "red" }}>*</b>
      </label>
      <input
        className="form-control"
        placeholder="Layout Name"
        maxLength={25}
        value={layoutName}
        onChange={(e) => {
          setlayoutName(e.target.value);
        }}
        style={{ marginBottom: "15px" }}
      ></input>
      <label>
        <b>Choose Layout </b>
      </label>
      <div className="row">
        <div
          className="col-4 layoutSelMain"
          onClick={() => setLayoutTypeDB("1")}
        >
          {layoutType === "1" ? (
            <div className="layoutImage activeLayout">
              <img src={layout1} alt="layoutImage"></img>
              <div className="layoutLabel">LAYOUT 1</div>
            </div>
          ) : (
            <div className="layoutImage">
              <img src={layout1} alt="layoutImage"></img>
              <div className="layoutLabel">LAYOUT 1</div>
            </div>
          )}
        </div>
        <div
          className="col-4 layoutSelMain"
          onClick={() => setLayoutTypeDB("2")}
        >
          {layoutType === "2" ? (
            <div className="layoutImage activeLayout">
              <img src={layout2} alt="layoutImage"></img>
              <div className="layoutLabel">LAYOUT 2</div>
            </div>
          ) : (
            <div className="layoutImage">
              <img src={layout2} alt="layoutImage"></img>
              <div className="layoutLabel">LAYOUT 2</div>
            </div>
          )}
        </div>
        <div
          className="col-4 layoutSelMain"
          onClick={() => setLayoutTypeDB("3")}
        >
          {layoutType === "3" ? (
            <div className=" activeLayout layoutImageCustom">
              <div className=" ">CREATE YOUR OWN CUSTOM LAYOUT</div>
              <div>
                <Button color="primary">
                  <FontAwesomeIcon className="iconPlusLayout" icon={faPlus} />
                </Button>
              </div>
            </div>
          ) : (
            <div className="layoutImage layoutImageCustom">
              <div className="">CREATE YOUR OWN CUSTOM LAYOUT</div>
              <div>
                <Button color="primary">
                  <FontAwesomeIcon className="iconPlusLayout" icon={faPlus} />
                </Button>
              </div>
            </div>
          )}
        </div>
        <Button
          color="primary"
          onClick={ProceedToThisLayout}
          className="ButtonProceed"
        >
          Proceed
        </Button>
      </div>
    </div>
  );
};

export default LayoutSelection;
